import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { NgApexchartsModule } from 'ng-apexcharts';

const modules = [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    NgApexchartsModule
]


@NgModule({
  declarations: [],
  imports: modules,
  exports: modules,
  providers: []
})
export class ApexChartsModule { }
